import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error('reality-alerts: VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are required');
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    storageKey: 'reality-alerts-auth',
  },
});

// Multi-schema helpers — the shared DB exposes several schemas via PostgREST.
// `alerts` must be added to Settings → API → Exposed schemas (see SETUP.md).
export const alertsDb = () => supabase.schema('alerts');
export const opsDb = () => supabase.schema('operations');
